import React, { useEffect, useState, useRef } from 'react'
import Menu from '../main/Menu'
import {
    getError, isUndNullEmpNew, setBadgeStatusGeneric, settings, getLanguageObj, getResponse, getProcessButtons, sendMessageCloseCurrentWindow,
    awaitDelay, getDtRowIndexNew, LoadingSection
} from '../../helpers/UtilsHelper'
import useAuth from '../../auth/useAuth';
import BotAdd from './BotAdd';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { BotClass } from '../../classes/bot/botClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { BotService } from '../../services/bots/BotService';
import TableIndex from '../main/TableIndex';

const { app, colors, firebase, html, icons, labels, messages, react, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const $ = window?.$;

const currentMethod = 'Bots - function';

export default function Bots({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let dataObj = {};
    const auth = useAuth();
    const isMount = useRef(true);
    const [process, setProcess] = useState({ showLoading: false });

    const dtBotsId = 'dtBots';
    const [bot, setBot] = useState({});
    const [processValues, setProcessValues] = useState({
        id: '',
        description: '',
        method: '',
        dtId: dtBotsId,
        dtRowId: 0,
        type: 0,
    });
    const [showModal, setShowModal] = useState(false);
    const [modules, setModules] = useState([]);
    const [events, setEvents] = useState([]);
    const [moduleEvents, setModuleEvents] = useState([]);
    const textAreaAnswerId = 'textAreaAnswer';
    //#endregion variables

    //#region methods (bot)
    const getBotAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'getBotAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: true }));

            setProcessValues({ ...processValues, id: id, description: description, method: subMethod, dtRowId: rowIndex, type: type });

            //#region variables
            let bot_ = BotClass?.getClass();
            //#endregion variables

            //#region process
            switch (type) {
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.bot?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                //#region delete data (bot)
                                preConfirmResponse = await BotService.deleteById({ id: id, token: auth?.account?.tokenVzLaML?.token, subMethod: currentMethod });
                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                $(`#${dtBotsId}`).DataTable().row(rowIndex).remove().draw(true);
                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                                //#endregion delete data (bot)
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        },
                    };

                    const swalresult = await Swal.fire({ ...swalProperties });
                    if (swalresult?.isConfirmed && swalresult?.value) {
                        response = swalresult?.value;
                    } else if (swalresult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    //#endregion show message
                    break;
                case 0:
                    bot_.id = uuidv4();
                    bot_.name = '';
                    bot_.accountId = auth?.account?.uid;
                    setBot(bot_);
                    break;
                case 1:
                    await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
                    window.location.href = `/botEdit/${id}`;
                    break;
                case 2:
                    response = await BotService.getById({ id: id, token: auth?.account?.tokenVzLaML?.token, subMethod: currentMethod });
                    if (!response?.isSuccess || response?.isWarning) return;
                    break;
                default:
                    return;
            }
            //#endregion process

            if (type === 0) {
                setModuleEvents([]);
                await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
                setShowModal(true);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let bots_ = [];
            let dtRows = [];
            let events_ = [];
            let modules_ = [];
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region set dataTable
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set dataTable

            //#region clear dataTable
            response = clearDataTable({ dtBots: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region set queryCode
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set queryCode

            //#region get data (bots)
            dataObj = {
                conditionals: [
                    { field: dbFields?.accountId, operator: dbOperators?.equal, value: auth?.account?.uid, }
                ],
                ordersBy: [
                    { field: dbFields?.name, value: dbOrdersBy?.asc, },
                ],
                limit: 0,
            };

            response = await BotService.getAll({ data: dataObj, token: auth?.account?.tokenVzLaML?.token, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            bots_ = response?.result?.bots || bots_;
            events_ = response?.result?.events || events_;
            setEvents(events_);
            setModuleEvents(events_);
            modules_ = response?.result?.modules || modules_;
            setModules(modules_);
            //#endregion get data (bots)

            //#region set dataTable
            if (!isUndNullEmpNew({ data: bots_, subMethod: currentMethod, })?.result && bots_?.length > 0) {
                bots_.map((detail) => (
                    dtRows.push([
                        detail?.name,
                        modules_.filter(({ id, }) => id === detail?.moduleId)?.[0]?.name?.[languageObj?.id],
                        events_.filter(({ id, }) => id === detail?.eventId)?.[0]?.name?.[languageObj?.id],
                        setBadgeStatusGeneric({
                            type: (detail?.status ? 0 : 1),
                            value: (detail?.status ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id])
                        }),
                        getProcessButtons({
                            id: detail?.id,
                            description: detail?.name,
                            detailsShow: false,
                            detailsLabel: labels?.detail?.[languageObj?.id],
                            detailsEnabled: false,
                            editShow: true,
                            editLabel: labels?.edit?.[languageObj?.id],
                            editEnabled: true,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            processButtons: [],
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        })?.result
                    ])
                ))
            }

            $(`#${dtBotsId}`).DataTable().rows.add(dtRows).draw(true);
            //#endregion set dataTable

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion methods (bot)

    //#region methods (others)
    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtBotsId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'asc']],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '45%', orderable: true, },
                    { title: labels?.module?.[languageObj?.id], width: '20%', orderable: true, },
                    { title: labels?.event?.[languageObj?.id], width: '20%', orderable: true, },
                    { title: labels?.status?.[languageObj?.id], width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtBotsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const clearDataTable = ({
        dtBots = false,
        subMethod = '',
    }) => {
        const currentMethod = 'clearDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (dtBots) $(`#${dtBotsId}`).DataTable().rows().remove().draw(true);
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let methodName = '';
            let description = '';
            //#endregion variables

            //#region process
            $(`#${dtBotsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndexNew({ dtId: dtBotsId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullEmpNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    methodName = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getBotAddEditDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                type: 1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            getBotAddEditDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                type: -1,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });

            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='bots' process='bots' processLevel1='' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.bots?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.bots?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}


                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.bots?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.bot} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.bots?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading}
                                                data-title={labels?.add?.[languageObj?.id]}
                                                onClick={(e) => getBotAddEditDelete({ e, id: '', description: '', rowIndex: 0, type: 0, subMethod: 'btnBotAdd' })}>
                                                <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i> {labels?.add?.[languageObj?.id] || 'Add'}
                                            </button>
                                        </div>
                                        <TableIndex tableId={dtBotsId} languageObj={languageObj} />
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <BotAdd processValues={{
                            $,
                            auth,
                            ...processValues,
                            showModal,
                            setShowModal,
                            bot,
                            setBot,
                            modules,
                            setModules,
                            events,
                            setEvents,
                            moduleEvents,
                            setModuleEvents,
                            textAreaAnswerId,
                        }} />
                    )}

                </section>
                {/* /.content */}
            </div >
        </div >
    )
}